<template>
  <div class="cv-wrap">

    <v-alert type="info" dense outlined class="mb-4" style="font-size:0.82rem;">
      <span class="red--text font-weight-bold">*</span>
      No use espacios en blanco ni caracteres como la <strong>ñ</strong>.
    </v-alert>

    <v-text-field
      v-model.trim="datos.login"
      label="Usuario *"
      outlined dense
      prepend-inner-icon="mdi-account-outline"
      :error-messages="validation.firstError('datos.login')"
      class="mb-1"
    />

    <v-text-field
      v-model.trim="datos.clave"
      label="Clave nueva *"
      outlined dense
      prepend-inner-icon="mdi-lock-outline"
      :error-messages="validation.firstError('datos.clave')"
      class="mb-3"
    />

    <Alertas ref="alertar" />

    <div class="d-flex justify-center mt-3">
      <v-btn color="indigo darken-1" dark depressed
        :disabled="$store.state.cambiarDatosAcceso == false"
        @click="actualizar">
        <v-icon left small>mdi-content-save-outline</v-icon> Actualizar datos
      </v-btn>
    </div>

    <notifications group="auth" position="bottom right" />
  </div>
</template>

<script>
import { Validator } from 'simple-vue-validator';
import Alertas from '@/components/AAlertas.vue';
import { parseJsonError } from '@/components/Utils.js';
import { getUserData } from '@/accessToken.js';
import gql from 'graphql-tag';

export default {
  components: { Alertas },
  data() {
    return {
      datos: {
        id: -1,
        login: null,
        clave: null,
      },
    };
  },
  validators: {
    'datos.login'(value) { return Validator.value(value).minLength(5).required(); },
    'datos.clave'(value) { return Validator.value(value).minLength(5).required(); },
  },
  methods: {
    actualizar() {
      const ex = getUserData();
      if (ex) {
        const userdata = this.$store.state.DATA_USER;
        if ((this.datos.clave + '').startsWith(userdata.num_doc)) {
          this.$refs.alertar.invalido('No puede usar su documento como subcadena inicial de la nueva clave.');
          return;
        }
      }
      this.$validate().then((success) => {
        var obj = window.Object.assign({}, this.datos);
        if (success) {
          this.$store.state.obj = obj;
          this.$store.dispatch('quitarNulos');
          this.$refs.alertar.cargando();
          this.enviarDatos(obj);
        } else {
          this.$refs.alertar.invalido('Revise los datos');
        }
      });
    },
    async enviarDatos(obj) {
      var vue = this;
      var sql = gql`mutation{ cambiarDatosAcceso(input:${window.stringifyObject(obj)}){ok,errors{message}} }`;
      this.$apollo.mutate({ mutation: sql })
        .then((data) => {
          if (data.data.cambiarDatosAcceso.ok) {
            vue.$refs.alertar.success();
          } else {
            var errores = JSON.parse(JSON.stringify(data.data.cambiarDatosAcceso.errors));
            var vals = '';
            errores.forEach(function(k) { vals += Object.values(k) + '-\n\t'; });
            vue.$refs.alertar.invalido(vals);
          }
        })
        .catch((error) => {
          vue.$refs.alertar.invalido();
          window.console.error(window.stringifyObject(error));
          this.$notify(parseJsonError(error, 'cambiarDatosAcceso'));
        });
    },
  },
  mounted() {
    var u = window.sessionStorage.xxusuario;
    if (u) {
      var xu = JSON.parse(u);
      if (xu) {
        this.datos.id = xu.id;
        this.datos.login = xu.login;
        this.datos.clave = xu.datos_personales.num_doc;
        this.datos.clave += xu.datos_personales.departamento.extension;
      }
    }
  },
};
</script>

<style scoped>
.cv-wrap {
  max-width: 480px;
  margin: 0 auto;
  padding: 24px 8px;
}
</style>
